var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#789D4A",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M11.964 14.643v14.732H22.01v-3.259M11.964 14.643H22.01m-10.045 0h-1.339v-2.01h3.348m8.036 2.01v11.473m0-11.473h6.027m-6.027 11.473h5.357m0 0v3.259h2.009-18.75m16.741-3.259h.67V14.643m0 0h1.339v-2.01H20m0 0v-2.008h-6.027v2.009m6.027 0h-6.027m1.25 6.228a1.63 1.63 0 1 1 3.259 0 1.63 1.63 0 1 1-3.259 0Zm0 6.518a1.63 1.63 0 1 1 3.259 0 1.63 1.63 0 0 1-3.259 0Z"
  })));
};
export default SvgApartment;